import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/competitionApply/index",
  name: "competitionIndex",
  component: function component() {
    return import("../../../views/competitionApply/competitionIndex/competitionIndex.vue");
  },
  meta: {
    foot: true,
    title: "赛事报名"
  }
}, {
  path: "/competitionApply/applyDetails/:id",
  name: "applyDetails",
  component: function component() {
    return import("../../../views/competitionApply/applyDetails/applyDetails.vue");
  },
  meta: {
    foot: true,
    title: "赛事详情"
  }
}, {
  path: "/competitionApply/myResult",
  name: "myResult",
  component: function component() {
    return import("../../../views/competitionApply/myResult/myResult.vue");
  },
  meta: {
    foot: true,
    title: "我的成绩"
  }
}, {
  path: "/competitionApply/studentManage",
  name: "studentManage",
  component: function component() {
    return import("../../../views/competitionApply/studentManage/studentManage.vue");
  },
  meta: {
    foot: true,
    title: "学员管理"
  }
}, {
  path: "/competitionApply/gameUser",
  name: "gameUser",
  component: function component() {
    return import("../../../views/competitionApply/gameUser/gameUser.vue");
  },
  meta: {
    foot: true,
    title: "赛事报名"
  }
}, {
  path: "/competitionApply/gameDetails",
  name: "gameDetails",
  component: function component() {
    return import("../../../views/competitionApply/gameDetails/gameDetails.vue");
  },
  meta: {
    foot: true,
    title: "参赛信息"
  }
}, {
  path: "/competitionApply/applyOrder",
  name: "applyOrder",
  component: function component() {
    return import("../../../views/competitionApply/applyOrder/applyOrder.vue");
  },
  meta: {
    foot: true,
    title: "报名记录"
  }
}, {
  path: "/competitionApply/applyForm",
  name: "applyForm",
  component: function component() {
    return import("../../../views/competitionApply/applyForm/applyForm.vue");
  },
  meta: {
    foot: true,
    title: "报名信息"
  }
}, {
  path: "/competitionApply/actionStudent",
  name: "actionStudent",
  component: function component() {
    return import("../../../views/competitionApply/actionStudent/actionStudent.vue");
  },
  meta: {
    foot: true,
    title: ""
  }
}];